import Highlight from "src/components/atoms/Highlight/Highlight";
import { type HighlightedListItemProps } from "./HighlightedListItem.types";

const HighlightedListItem = ({
    highlightProps,
    listItemProps,
}: HighlightedListItemProps) => {
    // Add null safety check
    if (!highlightProps) {
        return <li {...listItemProps}>No content available</li>;
    }

    return (
        <li {...listItemProps}>
            <Highlight {...highlightProps} />
        </li>
    );
};

export default HighlightedListItem;
